import {useEffect} from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Routers from "./Router";
import "./App.css";
import { ChakraProvider } from "@chakra-ui/react";
import { SetAuthToken, SetDefaultHeaders, TOKEN } from "./data/Config";
import useGenFetcher from "./data/useFetcher";

SetDefaultHeaders();

if (localStorage.getItem(TOKEN)) {
	SetAuthToken(localStorage.getItem(TOKEN));
}

const App = () => {
	let { loadUser } = useGenFetcher();

	useEffect(() => {
		loadUser();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="App">
			<ChakraProvider>
				<Router>
					<Routers />
				</Router>
			</ChakraProvider>
		</div>
	);
};

export default App;
